const OpenHelpCentreLink = (e: any): void => {
  e.preventDefault();
  window.open(
    'https://help.ellipsis.sc/hc/1313306050',
    '_blank',
    'noopener noreferrer'
  );
};
export default OpenHelpCentreLink;
